import { AbstractTailoredTemplateWidget } from '@/components/template-widgets/AbstractTailoredWidgetTemplate.class';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { ClassificationNodeId } from '../../../../interfaces/Classification.interface';
import { DashboardingProvider } from '../../../../providers/dashboarding.provider';
import { WidgetBusinessIndicatorsAdvancementComponent } from '../../details/components/widget-business-indicators-advancement/widget-business-indicators-advancement.component';
import type { BusinessIndicatorAdvancementConfig } from '../widgets-business-indicators.service';

@Component({
    selector: 'template-widget-business-indicator-advancement',
    imports: [ReactiveFormsModule, WidgetBusinessIndicatorsAdvancementComponent],
    templateUrl: './template-widget-business-indicator-advancement.component.html',
    styleUrl: './template-widget-business-indicator-advancement.component.scss'
})
export class TemplateWidgetBusinessIndicatorAdvancementComponent extends AbstractTailoredTemplateWidget<BusinessIndicatorAdvancementConfig> {
    private _dashboardingProvider = inject(DashboardingProvider);
    classificationNodeId = toSignal(this._dashboardingProvider.getSelectedNodeId$(), {
        initialValue: ClassificationNodeId.ALL_BUILDINGS_NODE
    });
    constructor() {
        super();
    }
}
